import React, {Fragment, useEffect, useState} from "react";
import './WeatherReportsChart.scss'
import {formatDate, formatDateWithTime} from "../helpers/helpers";
import ChartComponent from "./ChartComponent";


const WeatherReportsChart = props => {
    const {data, measurementPeriod} = props;

    const [chartData, setChartData] = useState([])
    const [selectedChartData, setSelectedChartData] = useState(null)
    const [innerPending, setInnerPending] = useState(false)

    useEffect(() => {
        createData(data)
    },[])

    const createData = (data) => {
        setInnerPending(true)
        const headers = data.headers.map((el, index) => (
            {id: index, name: el.mergedHeader, subHeaders: el.subHeaders.map((x, i) => ({label: el.mergedHeader, name: x}))}
        ))

        const flatHeaders = headers.map(el => el.subHeaders).flat()
        flatHeaders.forEach((el, i) => {
            el.id = i
        })

        flatHeaders.map((x) => {
            x.value =  data.values.map((el) => (
                [el[0], el[x.id]]
            ))
        })

        setChartData(flatHeaders)
        setSelectedChartData(definedCharts(flatHeaders))
        setInnerPending(false)
    }

    const definedCharts = (chartData) => {
        // Extract all unique labels, excluding empty labels
        const uniqueLabels = [...new Set(chartData.map(item => item.label))].filter(label => label !== "");

        // Initialize an array to hold arrays of processed data for each label
        let groupedProcessedData = [];
        // Process each label
        uniqueLabels.forEach(label => {
            // Filter data for the current label
            const filteredCharts = chartData.filter(x => x.label === label);

            // Determine the chart type based on the label
            const chartType = (label.toLowerCase() === 'rain fall' || label.toLowerCase() === 'opady') ? 'bar' : 'line';

            // Transform data format
            for (let i = 0; i < filteredCharts.length; i++) {
                filteredCharts[i].value = filteredCharts[i].value.map(y => ({date: y[0], value: y[1], chartType: chartType}));
            }

            // Construct array of objects with combined data for each date
            const dates = filteredCharts[0]?.value.map(el => el.date) || [];
            let arr = [];
            dates.forEach(date => {
                let newObj = {date: date, label: label, chartType: chartType};
                let presentedArr = [];

                filteredCharts.forEach(chart => {
                    chart.value.forEach(val => {
                        if (val.date === newObj.date) {
                            presentedArr.push({ name: chart.name, value: Number(val.value) });
                        }
                    });
                });

                newObj.presentedFields = presentedArr;
                arr.push(newObj);
            });

            // Sort and update date format
            const sortedArr = arr.sort((a, b) => new Date(a.date) - new Date(b.date));
            const updatedArr = sortedArr.map(item => {
                return {
                    ...item,
                    date: item.date, // Assuming determineDateRewrite is a defined function
                    chartType: chartType
                };
            });
            // Add this label's processed data to the grouped array
            groupedProcessedData.push(updatedArr);
        });

        return groupedProcessedData;
    };



    function determineDateRewrite(date) {
        if(measurementPeriod === 'MIN_30_PERIOD' || measurementPeriod === 'HOUR_1_PERIOD') {
            return formatDateWithTime(date)
        } else {
            return formatDate(date)
        }
    }

    if(innerPending) {
        return <div>loading</div>
    }

    const transformData = (data) => {
        // Flatten the data array
        const flattenedData = data.flat();
        // Create a map to hold merged data by date
        const mergedData = {};

        flattenedData.forEach(item => {
            const dateKey = item.date; // Assuming date format is fine as-is, otherwise convert it

            if (!mergedData[dateKey]) {
                mergedData[dateKey] = {
                    dateTimeCreated: dateKey,
                    presentedFields: []
                };
            }

            item.presentedFields.forEach(field => {
                const measurementType = getMeasurementType(item.label); // Define this function based on your labels
                mergedData[dateKey].presentedFields.push({
                    fieldLabel: `${item.label} ${field.name}`,
                    measurementType: measurementType,
                    measurementValue: field.value.toString(),
                    unit: getUnit(measurementType) // Define this function to determine the unit based on measurementType
                });
            });
        });
        return Object.values(mergedData);
    };

    const getMeasurementType = (label) => {
        if (label.includes('Air temperature')) return 'TEMPERATURE';
        if (label.includes('Humidity')) return 'HUMIDITY';
        if (label.includes('Rain fall')) return 'RAIN_AMOUNT';
        return 'OTHER'; // Default case
    };

    const getUnit = (measurementType) => {
        if (measurementType === 'TEMPERATURE') return '°C';
        if (measurementType === 'HUMIDITY') return '%';
        if (measurementType === 'RAIN_AMOUNT') return 'mm';
        return ''; // Default case
    };



    if(chartData.length > 0) {
        return (
            <>
                <div className="WeatherReportsChartsContainer">
                    <div className="WeatherReportsChart">
                        <ChartComponent data={transformData(selectedChartData)} />
                    </div>
                </div>
            </>
        )
    } else {
        return (
            <div> </div>
        )
    }


}

export default WeatherReportsChart
